export default __webpack_public_path__ + "static/media/goopter-ecommerce-self-ordering-scenarios.62e9d4e1.png";